import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { MicrositeSessionsState, AuthTokenState } from './coreAuth.models';
import { AppState } from '../core.state';

// Feature selector with explicit type parameters
export const selectMicrositeSessionsState = createFeatureSelector<MicrositeSessionsState>('micrositeSessions');

// Main selectors with explicit return types
export const selectMicrositeSessions: MemoizedSelector<AppState, MicrositeSessionsState> = createSelector(
  selectMicrositeSessionsState,
  (micrositeSessions: MicrositeSessionsState): MicrositeSessionsState => micrositeSessions
);

export const selectMicrositeSessionsIsLoggedIn: MemoizedSelector<AppState, boolean> = createSelector(
  selectMicrositeSessionsState,
  (micrositeSessions: MicrositeSessionsState): boolean => !!micrositeSessions.ext_id
);

export const selectMicrositeSessionsLoading: MemoizedSelector<AppState, boolean> = createSelector(
  selectMicrositeSessionsState,
  (micrositeSessions: MicrositeSessionsState): boolean => micrositeSessions.isLoading
);

export const selectMicrositeAuthToken: MemoizedSelector<AppState, AuthTokenState> = createSelector(
  selectMicrositeSessionsState,
  (micrositeSessions: MicrositeSessionsState): AuthTokenState => micrositeSessions.AuthToken
)
